import React from 'react';
import Section from './Section';
import '../../CommonCSS/SocietyCSS.css'

const SectionApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Section</h5>
          </div>
        </div>
        <Section/>
      </div>
    </div >
  );
};

export default SectionApp;
